<section id="changeFlightCard" class="theme-dark-blue card trip-updates" aria-labledby="tripUpdatesHeading">
  <div class="card-section">
      <h2 class="h3" id="tripUpdatesHeading">
        {{'reaccom.section.tripUpdatesInclude' | translate}}
        </h2>
        <ul>
          <li *ngFor="let tripUpdate of changeInfo.tripUpdates">
            {{ tripUpdate }}
          </li>
        </ul>
        <span *ngIf="changeInfo.disclaimerTexts?.length > 0">
          <hr role="presentation">
          <p *ngFor="let disclaimerText of changeInfo.disclaimerTexts">
            {{ disclaimerText }}
          </p>
        </span>
  </div>
</section>
